/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeiertagDto } from '../../models/feiertag-dto';

export interface GetFeiertage$Plain$Params {
  mitarbeiterId?: string;
}

export function getFeiertage$Plain(http: HttpClient, rootUrl: string, params?: GetFeiertage$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeiertagDto>>> {
  const rb = new RequestBuilder(rootUrl, getFeiertage$Plain.PATH, 'get');
  if (params) {
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeiertagDto>>;
    })
  );
}

getFeiertage$Plain.PATH = '/v1/feiertage';
